import { render } from "./HiForm.vue?vue&type=template&id=e7c169dc"
import script from "./HiForm.vue?vue&type=script&lang=js"
export * from "./HiForm.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__